import { faSteeringWheel } from '@fortawesome/pro-solid-svg-icons/faSteeringWheel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './Vehicle.module.scss';

interface VehicleProps {
    name: string;
    className?: string;
}

export const Vehicle: FunctionComponent<VehicleProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={styles.iconContainer}>
                <FontAwesomeIcon
                    className={styles.icon}
                    icon={faSteeringWheel}
                />
            </div>
            <div className={styles.nameContainer}>
                <span className={styles.name}>{props.name}</span>
            </div>
        </div>
    );
};

export default Vehicle;
